export default __webpack_public_path__ + "static/media/23.293a7b81.svg";